// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.npm
import '@babel/polyfill';

import Vue from 'vue';
import Vuex from 'vuex';
import {VueTranslate} from './plugins/vue-translate';
import {veeHelper} from './mixins/validation-helpers';
import {dataHelpers} from './mixins/helpers';



//Validation localization
import VeeValidate, { Validator } from 'vee-validate';
import en from 'vee-validate/dist/locale/en';
import fr from 'vee-validate/dist/locale/fr';

import Loader from '@/components/parts/loader';
import Translate from '@/components/parts/translate';
import Game from '@/components/parts/game';

window.validate = {
	dictionary: {
		en: en,
		fr: fr
	}
};



Vue.use(VeeValidate);

function validationMessage(tag, field, param){
	// eslint-disable-next-line
	let string = app.t(tag);

	if(typeof field !== 'undefined'){
		string = string.replace(/\$\{[ ]?field[ ]?\}/g, field);
	}

	if(typeof field !== 'undefined'){
		string = string.replace(/\$\{[ ]?param[ ]?\}/g, param);
	}


	return string;
}

function setRules(){
	Validator.extend('min_value_decimal', {
		getMessage: (field, [min]) => validationMessage('min_value_decimal', field, min),
		validate: function (value, [min]) {
			return parseFloat(value.replace(',', '.')) >= min;
		}
	});
	Validator.extend('max_value_decimal', {
		getMessage: function (field, [max]){
			return validationMessage('max_value_decimal', field, max)
		},
		validate: function (value, [max]) {
			return parseFloat(value.replace(',', '.')) <= max;
		}
	});
}

Vue.component('loader', Loader);
Vue.component('t', Translate);
Vue.component('game', Game);
Vue.use(VueTranslate);


import App from './App';

import store from './store';

import router from './router';
import {modal_helpers} from "./mixins/modal-helpers";


Vue.config.productionTip = false;

//Get plugins
require('./plugins/bootstrap');


//Get translations
/*import translation from './language/translations.js';*/

//Validation helper methods
Vue.mixin(veeHelper);
Vue.mixin(dataHelpers);
Vue.mixin(modal_helpers);
/*window.tr = translation;*/
/* eslint-disable no-new */


//Get site environment
store.dispatch('getEnv');

//Init application
window.app = new Vue({
	el: '#app',
	store,
	router,
	components: {App},
	template: '<App/>',
	locales: {},
	data: {
		refresh: {
			iterator: null,
			interval: 60e3 //60 seconds
		}

	},
	computed: {

		...Vuex.mapState([
			'lang',
			'refreshList',
			'translations'
		]),
		...Vuex.mapGetters([
			'maintenanceStatus'
		])
	},
	watch: {
		lang(lng) {
			this.$translate.setLang(lng);
			Validator.localize(lng, window.validate.dictionary[lng]);
			setRules();
		},
		translations(value) {
			this.$translate.setLang(this.lang);
			this.$translate.setLocales(value);
		},
		maintenanceStatus(value){
			if(value){
				this.$router.push({ name: 'Maintenance', query: { from: this.$route.fullPath } });
			}
		}
	},
	beforeMount() {
		//this.$store.dispatch('getEnv');
	},
	beforeDestroy() {
		clearInterval(this.refresh.iterator);
		window.removeEventListener('resize', this.updateViewport, true);
	},
	mounted() {
		this.$store.dispatch('getTranslations', this.lang);
		this.$store.dispatch('getMaintenanceStatus');//28-12-1990
		Validator.localize(this.lang, window.validate.dictionary[this.lang]);
		setRules();


		// eslint-disable-next-line
		/*if (testingStuff) {
			testingStuff(this);
		}*/

		this.refresh.iterator = this.refreshFactory();

		window.addEventListener('resize', this.updateViewport, true);
		this.updateViewport();
	},
	methods: {
		updateViewport(){
			console.log();
			this.$store.commit('setViewport', window.innerWidth)
		},

		refreshFactory() {
			//Start all refresh actions

			//initial update
			this.refreshAll();

			//Update in interval
			return setInterval(() => {
				this.refreshAll();

			}, this.refresh.interval)
		},
		refreshAll() {
			this.refreshList.forEach((refreshEl) => {

				//Dispatch VUEX request
				this.$store.dispatch(refreshEl);
			});
		}

	}

});





